import { MouseEvent, useCallback } from 'react';
import { useAnalytics } from '@provider-directory/components/analytics/analytics-provider';

export const useTrackAndOpenCall = (): ((
  clickText: string,
) => (e: MouseEvent<HTMLAnchorElement>) => void) => {
  const analytics = useAnalytics();

  return useCallback(
    (clickText: string) =>
      (e: MouseEvent<HTMLAnchorElement>): void => {
        e.preventDefault();
        analytics.calledEvent({
          linkContextPage: 'SearchResults',
          clickText,
          clickURL: e.currentTarget.href,
        });
        window.open(e.currentTarget.href);
      },
    [analytics],
  );
};
